module.exports = __webpack_public_path__ + "306d3a1a25a888470d5a415b91cd5103.png";